import { useEffect, useState } from 'react';
import '../Public.css';
import { Box, Button, Center, Divider, Flex, Grid, Image, Skeleton, Spacer, Text } from '@chakra-ui/react';
import { IDossier } from '../types';
import { getPublicDossiers } from '../API/dossier';
import BigDossierCard from '../Dossiers/BigDossierCard';
import { faBookOpen, faCalculator, faDoorOpen, faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../resources/adere_logo.svg';
import j_philippe from '../resources/j_philippe.jpeg';
import mg_pp from '../resources/mg.jpg';
import cd_pp from '../resources/cd.png';
import mvdb_pp from '../resources/mvdb.png';
import sm_pp from '../resources/sm.png';
import asd_pp from '../resources/asd.jpg';
import { SLIDER_IMAGES } from '../Home';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';

function TeamCard(props: { name: string, title: string, title2:string, title3:string, image: any, link:string }) {
  return (
    <Box
    onClick={() => {window.open(props.link, "_blank")}} 
    textAlign="center" w="300px" mb={[5, 5, 0]}>
          <Image
            cursor={'pointer'}
            className='hvr-grow'
            src={props.image}
            alt={props.name}
            boxSize="200px"
            objectFit="cover"
            borderRadius="full"
            mx="auto"
            mb={4}
          />
          <Text fontWeight="bold" fontSize="2xl" color="#006977" mb={0}>
            {props.name}
          </Text>
          <Text fontSize="sm" color="gray.600" mt={0} pt={0}>
            <Text as={'b'} fontSize={'md'}>{props.title}</Text><br/>{props.title2} {props.title3.length > 0 && <><br />{props.title3}</>}
          </Text>
    </Box>
  );
}

function Public() {
  // Dossiers
  const [openDossiers, setOpenDossiers] = useState<IDossier[]>([]);
  const [openDossiersFetched, setOpenDossiersFetched] = useState<boolean>(false);
  useEffect(() => {
    // High priority dossiers
    // getDossiers(1000, 0, "deadline", [], true, true, true).then((resp) => {
    // });
    // Open dossiers, not high priority
    getPublicDossiers(1000, 0, "deadline", [], false, true, true).then((resp) => {
      setOpenDossiers(resp.data.dossiers);
      setOpenDossiersFetched(true);
    });
  }, []);

  // Photo slider
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: 'start', dragFree: true }, [
    Autoplay({ delay: 3500, stopOnInteraction: false }),
  ]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());
    emblaApi.on('select', onSelect);
    return () => { emblaApi.off('select', onSelect); };
  }, [emblaApi]);


  return (<>
    <Box width={'100%'} pb={'30px'} borderBottom={'1pt solid #DDDDDD'} bgColor={'white'}>

      <Center>
        <Image src={logo} width={'350px'} mt={'40px'} />
      </Center>

      <Center mt={'30px'}>
        <Box p={4} width={'850px'} ms={5} me={5}>

          <Text mb={2} textAlign={'justify'} color={'#4A4A4A'}>
            <Text as={'b'}>L'Association des Directeurs/Directrices d'Équipe de Recherche et d'Enseignement (ADERE)</Text> a été créée en octobre 2023. Son objectif global est de représenter et de soutenir, sans distinction de statut, l'ensemble des directeurs/ directrices d'équipe de recherche et d'enseignement (DRE) de l'Université de Liège.
          </Text>

          <Text textAlign={'justify'} color={'#4A4A4A'}>
          <Text as={'b'}>L'ADERE promeut les intérêts de cette catégorie de personnel</Text> avec, comme ligne directrice, un idéal universitaire d'approfondissement des connaissances par la recherche, de contribution à la résolution des problèmes sociétaux en toute indépendance et de transmission du savoir aux générations futures à travers un enseignement de qualité.
          </Text>
        </Box>
      </Center>

      <Center mt={5} ms={[5, 5, 0]} me={[5, 5, 0]}>
        <Box border={'1pt solid #DDDDDD'} bgColor={"white"} width={"850px"} p={"20px"}>
          <Text mb={0} pb={0} fontWeight={'800'} color={"gray.700"} textAlign={'left'} fontSize={['3xl', '3xl', '2xl']} letterSpacing={"-.1rem"} cursor={'default'}>Devenez membre de l'ADERE</Text> 

          <Divider mt={4} mb={4} />

          <Text fontSize="md" color="#4A4A4A" mt={0} pt={0} textAlign={'justify'} mb={0}>
            Afin de devenir membre de l'ADERE, vous pouvez faire une demande d'accès via notre page d'accueil. L'ADERE est ouverte à tous les directeurs/directrices d'équipe de recherche et d'enseignement (DRE) de l'Université de Liège, sans distinction de statut.
          </Text>

          <Flex>
            <Spacer />

            <Button
              width={'fit-content'} 
              p={6}
              m={3}
              color={"white"} 
              _hover={{backgroundColor:"#006977"}} 
              bgColor={"#004851"} 
              size="md" 
              mt={5} 
              fontSize={'10pt'} 
              fontWeight={'700'} 
              letterSpacing={'.8px'} 
              onClick={() => { window.location.href = "/login" }}>
                ACCÉDER À LA PLATEFORME<FontAwesomeIcon size="lg" icon={faDoorOpen} style={{paddingLeft:"8px"}} />
            </Button>
          </Flex>
        </Box>

      </Center>

    </Box>

    <Center bgColor={"#FBFCFE"} pb={"40px"}>
      <Box width={['100%', '100%', '900px']} px={[5, 5, 0]}>

      <Text
      mt={"30px"}
      mb={1}
      ms={1}
      color={"#b44e50"}
      fontWeight={'900'}
      fontSize={'xl'}
      cursor={'default'}
      >
        ÉLECTIONS 2026 : Séance d'échange entre l'ADERE et les candidats à l'élection rectorale</Text>
      <Box mb={5} height={'3px'} bgColor={"#940104"} width={'100%'} />

      <Box boxShadow={"rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px"} p={6} bgColor={"white"} width={'100%'} border={'1pt solid #DDDDDD'}>
        <Text mb={3}>
          Le 14 avril 2026, le Bureau de l'ADERE a organisé une séance d'échange avec Anne-Sophie Nyssen et Damien Ernst, candidat·es à l'élection rectorale de l'Université de Liège.
        </Text>

        <Text>
          Cet événement a offert à nos membres l'opportunité d'interroger directement les candidats sur leurs programmes respectifs, et plus particulièrement sur la place qu'ils entendent accorder aux directeurs et directrices d'équipe de recherche et d'enseignement dans la gouvernance universitaire au cours de leur prochain mandat.
        </Text>

        {/* Photo slider */}
        <Box mt={5} overflow="hidden" borderRadius="md" ref={emblaRef} cursor="grab">
          <Flex>
            {SLIDER_IMAGES.map((src, i) => (
              <Box
                key={i}
                flex="0 0 auto"
                width={['85%', '55%', '38%']}
                me={3}
                borderRadius="md"
                overflow="hidden"
                boxShadow="rgba(0,0,0,0.12) 0px 4px 16px"
              >
                <img
                  src={src}
                  alt={`Photo ${i + 1}`}
                  style={{ width: '100%', height: '240px', objectFit: 'cover', display: 'block' }}
                  draggable={false}
                />
              </Box>
            ))}
          </Flex>
        </Box>

        {/* Dot indicators */}
        <Flex justify="center" gap={2} mt={3}>
          {SLIDER_IMAGES.map((_, i) => (
            <Box
              key={i}
              w={selectedIndex === i ? '20px' : '8px'}
              h="8px"
              borderRadius="full"
              bgColor={selectedIndex === i ? '#940104' : '#d0d0cc'}
              transition="all 0.3s ease"
              cursor="pointer"
              onClick={() => emblaApi?.scrollTo(i)}
            />
          ))}
        </Flex>
      </Box>

      </Box>
    </Center>

    <Box width={'100%'} pb={'50px'} borderBottom={'1pt solid #DDDDDD'} borderTop={'1pt solid #DDDDDD'}>

      <Center>
        <Box mb={0} pb={0} width={'900px'} mt={"20px"} textAlign={'left'}>
          <Text mb={0} pb={0} fontWeight={'900'} color={"#00707F"} textAlign={'left'} ps={[5, 5, 0]} fontSize={['5xl', '5xl', '6xl']} letterSpacing={"-.1rem"} cursor={'default'}>Dossiers en cours</Text> 
        </Box>
      </Center>

      <Center mb={"20px"} mt={'0px'}>
        <Box width={'900px'} >
          <Text textAlign={'justify'} color={'#4A4A4A'} ps={[5, 5, 0]} pe={[5, 5, 0]}>
              L'ADERE suit actuellement plusieurs dossiers touchant à la vie académique et professionnelle des DRE. Ces dossiers sont ouverts à la discussion et à la participation de tous les membres de l'ADERE. Pour les consulter et y contribuer, connectez-vous à la plateforme avec votre compte ULiège.
          </Text>
        </Box>
      </Center>

      <Center bgColor={"white"}>
        <Box bgColor={"white"} id='dossiers_banner' width={'900px'} p={[5, 5, 0]}>

          {!openDossiersFetched &&
            <Grid templateColumns={['repeat(1, 1fr)', 'repeat(1, 1fr)', 'repeat(1, 1fr)']} gap={6} mt={3} mb={6}>
              {[1, 2, 3, 4, 5, 6].map((_, index) => {
                return (
                  <Box key={index} mb={(index < 2) ? 2 : 0}>
                    <Skeleton key={index} boxShadow={"rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px"} height={'170px'} width={"900px"} />
                  </Box>
                )})}
            </Grid>
          }

          {openDossiers.map((dossier, index) => {
            return (
              <Box key={index} mb={(index < 2) ? 2 : 0}>
                <BigDossierCard demo={true} dossier={dossier} />
              </Box>
          )})}

        </Box>
      </Center>

    </Box>

    <Box width={'100%'} borderBottom={'1pt solid #DDDDDD'} pb={'50px'} bgColor={"#FBFCFE"}>

      <Center>
          <Box pb={0} width={'900px'} mt={"20px"} mb={"0"} textAlign={'left'}>
            <Text mb={0} pb={0} fontWeight={'900'} color={"#00707F"} textAlign={'left'} ps={[5, 5, 0]} fontSize={['5xl', '5xl', '6xl']} letterSpacing={"-.1rem"} cursor={'default'}>Fil d'Actualité</Text> 
          </Box>
      </Center>

      {/* <Center ms={[5, 5, 0]} me={[5, 5, 0]} mb={5}>
        <Box border={'1pt solid #DDDDDD'} bgColor={"white"} width={"900px"} p={"35px"}>
          {(() => {
            const now = new Date();
            const start = new Date('2025-10-21T00:00:00');
            const end = new Date('2025-12-10T00:00:00');
            if (now >= start && now < end) {
              return (
                <>
                  <Text mb={3} ms={3} color={"#b44e50"} fontWeight={'800'} fontSize={'sm'}>NOUVEAU - 21 octobre 2025</Text>
                  <Box mb={4} height={'4px'} bgColor={"#940104"} width={'100%'} />
                </>
              );
            }
            return null;
          })()}

          <Text mb={0} pb={0} fontWeight={'800'} color={"gray.700"} textAlign={'left'} fontSize={['3xl', '3xl', '2xl']} letterSpacing={"-.1rem"} cursor={'default'}>Séances de présentation et de débat</Text>

          <Divider mt={4} mb={4} />

          <Text fontSize="md" color="#4A4A4A" mt={0} pt={0} textAlign={'justify'} mb={4}>
            L'ADERE invite l'ensemble des DRE de la communauté universitaire à des séances de présentation et de débat autour de son manifeste. Trois séances sont prévues :
          </Text>

          <List spacing={3} ms={2}>
            <ListItem fontWeight={600}>
              <ListIcon
                verticalAlign="middle"
                as={FontAwesomeIcon}
                icon={faCalendar}
                color="#004851"
              />
                Le jeudi 20 novembre, 12-14h, <Link href="https://www.campus.uliege.be/cms/c_1813067/fr/b8-maison-des-etudiants-et-exedre-dick-annegarn" color={'blue.500'} target="_blank">amphithéâtre de l'Exèdre</Link>, Sart-Tilman ;
            </ListItem>
            <ListItem fontWeight={600}>
              <ListIcon
                verticalAlign="middle"
                as={FontAwesomeIcon}
                icon={faCalendar}
                color="#004851"
              />
                Le lundi 8 décembre, 12-14h, salle Lumière, (A1, 2ème étage), place du 20 Août ;
            </ListItem>
            <ListItem fontWeight={600}>
              <ListIcon
                verticalAlign="middle"
                as={FontAwesomeIcon}
                icon={faCalendar}
                color="#004851"
              />
                <i style={{color:"#940204"}}>(Local changé)</i> Le lundi 15 décembre, 12-14h, salle PhV (Physiologie végétale), Gembloux Agro-Bio-Tech.
            </ListItem>
          </List>

          <Flex>
            <Spacer />
            <Text fontSize="sm" color="#4A4A4A" mt={0} pt={0} textAlign={'justify'} fontWeight={'bold'}>
              21 octobre 2025
            </Text>
          </Flex>
        </Box>
      </Center> */}

      <Center ms={[5, 5, 0]} me={[5, 5, 0]} mb={5}>
        <Box border={'1pt solid #DDDDDD'} bgColor={"white"} width={"900px"} p={"35px"}>
          {(() => {
            const now = new Date();
            const start = new Date('2025-09-10T00:00:00');
            const end = new Date('2025-10-10T00:00:00');
            if (now >= start && now < end) {
              return (
                <>
                  <Text mb={3} ms={3} color={"#b44e50"} fontWeight={'800'} fontSize={'sm'}>NOUVEAU - 10 septembre 2025</Text>
                  <Box mb={4} height={'4px'} bgColor={"#940104"} width={'100%'} />
                </>
              );
            }
            return null;
          })()}

          <Text mb={0} pb={0} fontWeight={'800'} color={"gray.700"} textAlign={'left'} fontSize={['3xl', '3xl', '2xl']} letterSpacing={"-.1rem"} cursor={'default'}>Manifeste ADERE 2025</Text> 

          <Divider mt={4} mb={4} />

          <Text fontSize="md" color="#4A4A4A" mt={0} pt={0} textAlign={'justify'} mb={4}>
            Ce manifeste reprend une série de propositions dont le but est d'améliorer les conditions de travail des Directeurs d'Equipes de Recherche et d'Enseignement au sein de l'Uliège et le retentissement international de notre université.
          </Text>

          <Text fontSize="md" color="#4A4A4A" mt={0} pt={0} textAlign={'justify'} mb={4}>
            Ces propositions émanent d'une consultation de nos membres et ont été soumises au vote. La méthodologie suivie pour la consultation, l'instruction des dossiers et le vote est décrite dans le document.
          </Text>

          <Flex>
            <Spacer />
            <Text fontSize="sm" color="#4A4A4A" mt={0} pt={0} textAlign={'justify'} fontWeight={'bold'}>
              10 septembre 2025
            </Text>
          </Flex>

          <Flex>
            <Spacer />
            <Button
              width={'fit-content'} 
              p={6} 
              m={3} 
              color={"white"} 
              _hover={{backgroundColor:"#006977"}} 
              bgColor={"#004851"} 
              size="md" 
              mt={5} 
              fontSize={'10pt'} 
              fontWeight={'700'} 
              letterSpacing={'.8px'} 
              onClick={() => { window.open("/adere-manifeste-2025.pdf", "_blank") }}>
                LIRE LE MANIFESTE<FontAwesomeIcon size="lg" icon={faBookOpen} style={{paddingLeft:"8px"}} />
            </Button>
          </Flex>
        </Box>
      </Center>

      <Center ms={[5, 5, 0]} me={[5, 5, 0]} mb={5}>
        <Box border={'1pt solid #DDDDDD'} bgColor={"white"} width={"900px"} p={"35px"}>
          {(() => {
            const now = new Date();
            const start = new Date('2025-06-08T00:00:00');
            const end = new Date('2025-07-08T00:00:00');
            if (now >= start && now < end) {
              return (
                <>
                  <Text mb={3} ms={3} color={"#b44e50"} fontWeight={'800'} fontSize={'sm'}>NOUVEAU - 8 juin 2025</Text>
                  <Box mb={4} height={'4px'} bgColor={"#940104"} width={'100%'} />
                </>
              );
            }
            return null;
          })()}

          <Text mb={0} pb={0} fontWeight={'800'} color={"gray.700"} textAlign={'left'} fontSize={['3xl', '3xl', '2xl']} letterSpacing={"-.1rem"} cursor={'default'}>Note sur la réforme des pensions des professeurs d'universités belges</Text> 

          <Text fontSize="md" color="#4A4A4A" mt={0} pt={0} fontWeight={'bold'}>
            Résultats de l'étude de l'UNIFRA menée sur base des données récoltées par le simulateur de pension
          </Text>

          <Divider mt={4} mb={4} />

          <Text fontSize="md" color="#4A4A4A" mt={0} pt={0} textAlign={'justify'} mb={4}>
            Cette étude a été menée par un groupe interuniversitaire, indépendant, sans appartenance politique. Le groupe veut privilégier le dialogue avec le monde politique afin de proposer des solutions équitables en documentant le plus précisément et objectivement possible l'impact des réformes sur les universités et le personnel universitaire.
          </Text>
          <Text fontSize="md" color="#4A4A4A" mt={0} pt={0} textAlign={'justify'}>
            Ce rapport se focalise sur l'analyse de l'impact des réformes sur la pension des professeurs d'université qui sont, avec les magistrats, proportionnellement les plus impactés par l'ensemble, cumulatif, des propositions. Ce travail d'objectivation devra se poursuivre en documentant les conséquences des réformes sur les autres corps universitaires (scientifiques et personnel administratif, technique et ouvrier), également fortement affectés par les mesures annoncées.
          </Text>

          <Flex>
            <Spacer />
            <Text fontSize="sm" color="#4A4A4A" mt={0} pt={0} textAlign={'justify'} fontWeight={'bold'}>
              8 juin 2025
            </Text>
          </Flex>

          <Flex>
            <Spacer />
            <Button
              width={'fit-content'} 
              p={6} 
              m={3} 
              color={"white"} 
              _hover={{backgroundColor:"#006977"}} 
              bgColor={"#004851"} 
              size="md" 
              mt={5} 
              fontSize={'10pt'} 
              fontWeight={'700'} 
              letterSpacing={'.8px'} 
              onClick={() => { window.open("https://public.pension.uni-fra.org/simulation", "_blank") }}>
                ACCÉDER AU SIMULATEUR <FontAwesomeIcon size="lg" icon={faCalculator} style={{paddingLeft:"8px"}} />
            </Button>
            <Button
              width={'fit-content'} 
              p={6} 
              m={3} 
              color={"white"} 
              _hover={{backgroundColor:"#006977"}} 
              bgColor={"#004851"} 
              size="md" 
              mt={5} 
              fontSize={'10pt'} 
              fontWeight={'700'} 
              letterSpacing={'.8px'} 
              onClick={() => { window.open("/UNIFRA-reforme-pensionFinal.pdf", "_blank") }}>
                LIRE LA NOTE <FontAwesomeIcon size="lg" icon={faBookOpen} style={{paddingLeft:"8px"}} />
            </Button>
          </Flex>
        </Box>
      </Center>

      <Center ms={[5, 5, 0]} me={[5, 5, 0]} mb={5}>
        <Box border={'1pt solid #DDDDDD'} bgColor={"white"} width={"900px"} p={"35px"}>
          <Text mb={0} pb={0} fontWeight={'800'} color={"gray.700"} textAlign={'left'} fontSize={['3xl', '3xl', '2xl']} letterSpacing={"-.1rem"} cursor={'default'}>Carte Blanche : Un avenir sombre pour les universités francophones</Text> 

          <Text fontSize="md" color="#4A4A4A" mt={0} pt={0} fontWeight={'bold'}>
            Plus de 2000 membres du corps universitaire s'unissent pour sauver la recherche, l'enseignement et la prospérité.
          </Text>

          <Divider mt={4} mb={4} />

          <Text fontSize="md" color="#4A4A4A" mt={0} pt={0} textAlign={'justify'} mb={4}>
            Les universités de la Fédération Wallonie-Bruxelles (FWB) sont confrontées à une combinaison d'évolutions et de réformes gouvernementales qui dégradent leur efficacité et leur attractivité. A moins d'inverser ces tendances, la qualité de l'enseignement et de la recherche dans nos universités déclinera ce qui mettra gravement en péril leur attractivité.
          </Text>
          <Text fontSize="md" color="#4A4A4A" mt={0} pt={0} textAlign={'justify'}>
            Nous appelons nos responsables politiques à réagir pour éviter cette catastrophe tant qu'il est encore temps. Une initiative interuniversitaire est en cours afin de rappeler l'importance des universités dans la formation du capital humain, la recherche, l'innovation et l'économie d'une région.
          </Text>

          <Flex>
            <Spacer />
            <Text fontSize="sm" color="#4A4A4A" mt={0} pt={0} textAlign={'justify'} fontWeight={'bold'}>
              1er mai 2025
            </Text>
          </Flex>

          <Flex>
            <Spacer />
            <Button
              width={'fit-content'} 
              p={6} 
              m={3} 
              color={"white"} 
              _hover={{backgroundColor:"#006977"}} 
              bgColor={"#004851"} 
              size="md" 
              mt={5} 
              fontSize={'10pt'} 
              fontWeight={'700'} 
              letterSpacing={'.8px'} 
              onClick={() => { window.open("http://carte.uni-fra.org", "_blank") }}>
                SIGNER LA CARTE BLANCHE <FontAwesomeIcon size="lg" icon={faFileSignature} style={{paddingLeft:"8px"}} />
            </Button>
          </Flex>
        </Box>
      </Center>

    </Box>

    <Box borderBottom={'1pt solid #DDDDDD'} pb={'50px'} bgColor={"#FBFCFE"}>
      <Center pt={'40px'} bgColor={"#FBFCFE"}>
        <Box width={'900px'}>
          <Text fontWeight={'900'} color={"#E6332A"} ps={[5, 5, 0]} fontSize={['5xl', '5xl', '6xl']} letterSpacing={"-.1rem"} cursor={'default'}>Bureau de l'ADERE</Text> 
        </Box>
      </Center>

      <Center py={10} bgColor={"#FBFCFE"}>
        <Flex
          wrap="wrap"
          justify="center"
          gap={0}
          maxW="900px"
        >
          {TeamCard({name:"Marilaure Grégoire", image:mg_pp, title:"Professeure Ordinaire", title2:"Porte-parole ADERE", title3:"Faculté des Sciences", link:"https://www.uliege.be/cms/c_9054334/fr/repertoire?uid=U016063"})}

          {TeamCard({name:"Christophe Desmet", image:cd_pp, title:"Maître de Recherche du FNRS", title2:"Faculté de Médecine Vétérinaire", title3:"",link:"https://www.uliege.be/cms/c_9054334/fr/repertoire?uid=U191837"})}

          {TeamCard({name:"Anne-Sophie Duwez", image:asd_pp, title:"Professeure Ordinaire", title2:"Faculté des Sciences", title3:"",link:"https://www.uliege.be/cms/c_9054334/fr/repertoire?uid=U203522"})}

        </Flex>
      </Center>

      <Center bgColor={"#FBFCFE"}>
        <Flex
          wrap="wrap"
          justify="center"
          gap={0}
          maxW="900px"
        >

          {TeamCard({name:"Philippe Jacques", image:j_philippe, title:"Professeur Ordinaire", title2:"Gembloux Agro-Bio Tech", title3:"", link:"https://www.gembloux.uliege.be/cms/c_4039847/fr/gembloux-repertoire?uid=u026506"})}

          {TeamCard({name:"Steve Majerus", image:sm_pp, title:"Professeur Ordinaire", title2:"Faculté de Psychologie, de Logopédie et des Sciences de l'Education", title3:"", link:"https://www.uliege.be/cms/c_9054334/fr/repertoire?uid=u182078"})}

          {TeamCard({name:"Marc Van Droogenbroeck", image:mvdb_pp, title:"Professeur Ordinaire", title2:"Faculté des Sciences Appliquées", title3:"", link:"https://www.uliege.be/cms/c_9054334/fr/repertoire?uid=u182591"})}
          
        </Flex>
      </Center>

    </Box>

  </>);
}

export default Public;